<template>
	<div>
		<div class="case_container" v-for="(item,i) in customerData" :key="i">
			<div class="line">

			</div>
			<el-tabs class="case_tabs" v-model="item.Id+i+1">
				
				<el-tab-pane label="项目背景" :name="item.Id+i+1">
					<div class="case_tabs_msg">
						<div v-html="item.ProjectBackground" style="font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #333333;
line-height: 22px;"></div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="解决方案" :name="item.Id+i">
					<div class="case_tabs_msg">
						<div v-html="item.Solution">
				
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			<img class="case_img" :src="item.img2">
		</div>

	</div>
</template>

<script>
	import { scrollAnimation } from '../../../utils/js/scrollAnimation.js';
	import {
		customer
	} from '../../../common/api.js'
	export default {

		data() {
			return {
				customer,
				activeName: "",
				customerData: []
			}
		},
		created() {
			this.getCustomer()
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			if(currentY==0) return;
			scrollAnimation(currentY, 800)
			
		},
		methods: {
			async getCustomer() {
				let res = await this.customer({
					PageIndex: 1,
					PageSize: 10000
				});
				this.customerData = res.data.Data
				this.activeName = res.data.Data.map(t => {
					t.Id
				})
			},
		}
	}
</script>
<style>
	.el-tabs__item {
		font-size: 1rem !important;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		margin-top: 0.5rem;
	}

	.el-tabs__nav-wrap::after {
		background-color: white !important;
	}

	.el-tabs__nav-scroll {
		width: 18.75rem !important;
		margin: 0 auto !important;
	}

	.case_tabs_msg span {
		font-size: 16px !important;
		font-size: 16px !important;
		font-family: PingFangSC-Regular, PingFang SC !important;
		font-weight: 400 !important;
		color: #333333 !important;
	}

	.case_tabs_msg p {
		line-height: 22px !important;
	}
</style>
<style lang="less" scoped>
	.case_container {
		width: 75rem;
		height: 22.0625rem;
		margin: 5rem auto;
		position: relative;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		box-shadow: 0px 11px 24px 10px rgba(230, 230, 230, 0.5);

		span {}

		.case_img {
			width: 22.5rem;
			height: 22.0625rem;
			transform: scale(0.5);
		}

		.case_tabs {
			margin: 0 auto;
		}

		.line {
			width: 0.0625rem;
			height: 17.9375rem;
			background-color: #F2F2F2;
			position: absolute;
			right: 22.8rem;
			top: 2rem;
		}

		.case_tabs_msg {
			width: 740px;
			// height: 88px;
			font-size: 16px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
			margin-top: 5rem;

		}


	}
</style>
